import React, { useState } from 'react';
import { Avatar, Box, Button, Divider, Flex, IconButton, Input } from '@chakra-ui/react';
import { Edit, EditOutlined } from '@mui/icons-material';
import harpreetLogo from './../TopBar/harpreet.png';
import apiClient from '../clients/apiClient.js';

function OrganizationalInfo({
  name,
  canEditOrgData,
  logo,
  isEditing,
  setIsEditing,
  refreshData,
}) {
  const [organization, setOrganization] = useState({
    name,
    logo,
  });

  React.useEffect(() => {
    setOrganization({ name, logo });
  }, [name, logo]);

  console.log('OrganizationalInfo:', { name, logo, isEditing });

  const handleEditClick = () => setIsEditing(!isEditing);

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    setOrganization({ ...organization, [name]: value });
  };

  const handleSave = async () => {
    let organisation_info = {
      name: organization.name,
    }

    apiClient.post('/manage-account', {
      organisation_info
    }).then(({ data }) => {
      setIsEditing(false); // Exit edit mode after saving
      refreshData(); // Refresh data from server
    })
  };

  const handleOrgLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setOrganization({ ...organization, logo: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      <Flex justifyContent={'space-between'}>
        <Box fontSize={'24px'} fontWeight={600}>
          Organizational info
        </Box>
        {isEditing ? (
          <Flex gap={2}>
            <Button
              onClick={() => setIsEditing(false)}
              size="sm"
              variant="ghost"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSave}
              bg={'#2584FD'}
              _hover={{ bg: '#2584FD' }}
              color={'white'}
              size="sm"
              marginRight={"8px"}
            >
              Save
            </Button>
          </Flex>
        ) : canEditOrgData ? (
          <Button onClick={handleEditClick} size="sm" marginX={"8px"}>
            Edit
          </Button>
        ) : null}
      </Flex>
      <Box py={4}>
        <Divider />
      </Box>
      <Flex flexDir={'column'} gap={8}>
        <Flex>
          <Box width={'180px'} fontWeight={'500'}>
            Organization name
          </Box>

          {isEditing ? (
            <Input
              type="text"
              name="name"
              value={organization.name}
              onChange={handleNameChange}
              maxWidth={'240px'}
            />
          ) : (
            <Box>{name}</Box>
          )}
        </Flex>
      </Flex>
    </div>
  );
}

export default OrganizationalInfo;
